export default "<div class=\"editGroupDetailsPage\">\n  <h4>Edit Group Details</h4>\n</div>\n"